
import interieur from "../assets/interieur.jpeg"
import sound from "../assets/sound.jpeg"
import puissance from "../assets/puissance.jpeg"
import autonomie from "../assets/autonomie.jpeg"
import carSound from '../assets/car-sound.mp3';

const carPoints = [
    {
        id: 'connectivity',
        position: { top: '20%', left: '15%' },
        title: 'Connectivité Intelligente',
        description: 'La technologie avancée de VOLTAUTO est la véritable innovation. Du moment où vous ouvrez l application jusqu à l expérience immersive en voiture, chaque interaction est conçue pour être instantanée, intuitive et exactement comme vous le souhaitez.',
        image: interieur,
    },
    {
        id: 'sound',
        position: { top: '50%', right: '15%' },
        title: 'Signature Sonore',
        description: 'Un son unique, conçu pour allier performance et émotion, offrant une expérience audio immersive qui accentue la puissance du véhicule tout en créant une atmosphère inoubliable.',
        image: sound,
        hasAudio: true,
        audioFile: carSound
    },
    {
        id: 'power',
        position: { top: '30%', right: '20%' },
        title: 'Puissance',
        value: '1,200+',
        unit: 'hp',
        description: 'Doté d’une motorisation électrique de pointe, notre véhicule offre plus de 1 200 chevaux pour une performance exceptionnelle. Grâce à une technologie avancée, il combine efficacité énergétique, accélération rapide, et respect de l’environnement, redéfinissant les standards de la mobilité électrique.',
        image: puissance,
    },
    {
        id: 'range',
        position: { top: '50%', left: '20%' },
        title: 'Autonomie',
        value: '516',
        unit: 'mi',
        description: 'Avec une autonomie de 516 miles (cycle WLTP), ce véhicule combine une batterie haute capacité et une gestion énergétique optimisée pour des trajets quotidiens et longues distances.',
        image: autonomie,
    }
];


export default carPoints